import React, { useEffect } from 'react';
import styles from './pipelineTemplatesPage.module.scss';
import { QUERY_SIDEBAR_CATEGORIES } from '../constants/pipeline-templates';
import CategoriesSidebar from '../features/CategoriesSidebar';
import TemplatesActionsHeader from '../features/TemplatesActionsHeader';
import TemplatesList from '../features/TemplatesList';
import usePipelineTemplates from '../hooks/usePipelineTemplates';

const PipelineTemplatesPage = () => {
  const { resetPipelineTemplates, setTemplatesSearchValue } = usePipelineTemplates();

  useEffect(() => {
    setTemplatesSearchValue('');

    return () => {
      resetPipelineTemplates();
    };
  }, []);

  return (
    <div className={styles.wrapper} data-testid="templates_page">
      <div className={styles.container}>
        <CategoriesSidebar categories={QUERY_SIDEBAR_CATEGORIES} />
        <div className={styles.content}>
          <TemplatesActionsHeader />
          <TemplatesList />
        </div>
      </div>
    </div>
  );
};

export default PipelineTemplatesPage;
